// import { apiUtils } from "@centivo-business/utils";
import { useQuery, useInfiniteQuery } from '@tanstack/react-query'
import { useCallback, useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import SharedTable from './SharedTable'
import debounce from 'lodash.debounce';
import Select from 'react-select';
import { fetchBenefitProvisionFact, fetchBnftPlanComp, fetchCategories, fetchTemplateRiderComp, fetchTemplates } from '../../utils/apiUtils';
import SyncData from './SyncData';

const size = 10;

const Templates = () => {

    const [showSync, setShowSync] = useState(false)
    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState()

    const [searchByRiderKey, setSearchByRiderKey] = useState()
    const [filterValue, setFilterValue] = useState();
    const [decouncedFilterValue, setDecouncedFilterValue] = useState()

    const [selectedTemplateOption, setSelectedTemplateOption] = useState(null); // Initialize with null for no selection
    const [selectedCategoryOption, setSelectedCategoryOption] = useState(null); // Initialize with null for no selection

    const [isDefaultComponentFilter, setIsDefaultComponentFilter] = useState(false)
    const [showMoreColumns, setShowMoreColumns] = useState(false)
    const { ref, inView } = useInView()

    const { data: templateOptions } = useQuery({
        queryKey: ['templates'],
        queryFn: fetchTemplates
    })

    const { data: categoriesOptions } = useQuery({
        queryKey: ['categories', selectedTemplateOption],
        queryFn: async () => await fetchCategories(selectedTemplateOption?.value)
    })

    const {
        data,
        error,
        fetchNextPage,
        hasNextPage,
        isLoading,
        isFetching,
        isFetchingNextPage,
        status,

    } = useInfiniteQuery(
        {
            queryKey: ['fetchTemplateRiderComp', selectedTemplateOption, selectedCategoryOption, decouncedSearchValue, decouncedFilterValue, isDefaultComponentFilter, searchByRiderKey],
            queryFn: async ({ pageParam }) => {
                let params = pageParam || {}

                if (selectedTemplateOption) {
                    params['benefitPlanTemplateKey'] = selectedTemplateOption.value //benefitPlanTemplateKey
                }

                if (selectedCategoryOption) {
                    params['category'] = selectedCategoryOption.value //benefitPlanTemplateKey
                }

                if (isDefaultComponentFilter) {
                    params['isDefaultComponent'] = isDefaultComponentFilter
                }

                if (searchByRiderKey) {
                    params['riderKey'] = searchByRiderKey
                }

                if (decouncedSearchValue) {
                    params.searchText = decouncedSearchValue.toLowerCase()

                }

                if (decouncedFilterValue) {
                    params.filterText = decouncedFilterValue.toLowerCase()
                }
                return await fetchTemplateRiderComp({ ...params, size })
            },
            initialPageParam: 0,
            getNextPageParam: (lastPage, pages) => {
                const lastItem = lastPage.hits?.hits.at(-1)
                if (!lastItem || (lastPage.hits?.hits.length < size)) return undefined
                return { searchAfter: lastItem.sort }

            },
        }
    )

    useEffect(() => {
        if (inView) {
            fetchNextPage()
        }
    }, [inView])

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    const debouncedFilterChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedFilterValue(event.target.value?.trim());
        }, 500),
        []
    );


    const results = data?.pages?.map(page => page.hits?.hits)?.flat();

    const columns = showMoreColumns ?
        ['_id', 'benefitPlanRiderKey', 'benefitPlanRiderTypeKey', 'benefitPlanRiderHccId', 'benefitPlanRiderDesc', 'riderVersionEffDateKey', 'riderVersionExpDateKey',
            'benefitPlanCompKey', 'bnftPlanCompHistFactKey', 'benefitPlanCompName', 'compVersionEffDateKey', 'compVersionExpDateKey',
            'benefitPlanTemplateKey', 'bnftPlanTemplateHstFctKey', 'benefitPlanTemplateName', 'category', 'slotName', 'templateVersionEffDateKey', 'templateVersionExpDateKey'] :
        ['benefitPlanRiderHccId', 'benefitPlanRiderDesc', 'benefitPlanCompName', 'benefitPlanTemplateName', 'category', 'benefitPlanRiderTypeName', 'slotName']

    return (
        <div className={'container '}>
            <p className='title'>Templates</p>
            <p className="sub-title">Riders and their corresponding components. Manually <span className='clickable-link' onClick={() => setShowSync(!showSync)}>{showSync ? 'filter' : 'sync'}</span></p>

            {showSync ? <SyncData onSubmitHandler={() => setShowSync(false)} /> : <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>
                        <Select
                            name={'template'}
                            className="react-select-container large-input"
                            classNamePrefix="react-select"
                            placeholder={'Filter by template'}
                            // inputRef={field.ref}
                            options={templateOptions}
                            value={selectedTemplateOption} // Pass the state variable here
                            onChange={(option) => { setSelectedCategoryOption(null); setSelectedTemplateOption(option) }}
                        // value={options.find((c) => c.value === field.value)}
                        // onChange={(val) => field.onChange(val.value)}
                        />

                        <Select
                            name={'category'}
                            className="react-select-container large-input"
                            classNamePrefix="react-select"
                            placeholder={'Filter by category'}
                            // inputRef={field.ref}
                            options={categoriesOptions}
                            value={selectedCategoryOption} // Pass the state variable here
                            onChange={(option) => { setSelectedCategoryOption(option) }}
                        // value={options.find((c) => c.value === field.value)}
                        // onChange={(val) => field.onChange(val.value)}
                        />

                        <input
                            style={{ fontSize: '1rem', minWidth: '250px', margin: ' 0rem', padding: '1rem', borderRadius: '.4rem', border: '1px solid var(--lighterGrey)', outline: 'none' }}
                            type="text"
                            id={'search'}
                            placeholder="search..."
                            // list="items"
                            autoComplete="off"
                            // onFocus={() => setCurrentPage(0)}
                            onChange={(e) => {
                                setSearchValue(e.target.value);
                                debouncedChangeHandler(e);
                            }}
                            value={searchValue}
                        />

                        <input
                            style={{ fontSize: '1rem', minWidth: '250px', margin: '0rem', padding: '1rem', borderRadius: '.4rem', border: '1px solid var(--lighterGrey)', outline: 'none' }}
                            type="text"
                            id={'filter'}
                            placeholder="Filter..."
                            // list="items"
                            autoComplete="off"
                            // onFocus={() => setCurrentPage(0)}
                            onChange={(e) => {
                                setFilterValue(e.target.value);
                                debouncedFilterChangeHandler(e);
                            }}
                            value={filterValue}
                        />

                        <input
                            style={{ fontSize: '1rem', minWidth: '250px', margin: '0rem', padding: '1rem', borderRadius: '.4rem', border: '1px solid var(--lighterGrey)', outline: 'none' }}
                            type="text"
                            id={'riderKey'}
                            placeholder="Rider Key..."
                            // list="items"
                            autoComplete="off"
                            // onFocus={() => setCurrentPage(0)}
                            onChange={(e) => {
                                setSearchByRiderKey(e.target.value)
                            }}
                            value={searchByRiderKey}
                        />

                    </div>

                    {/* <button style={{ maxHeight: '40px' }} onClick={() => setIsDrawerOpen((prevState) => !prevState)} className='gradient-button'>Ask AI</button> */}


                </div>

                <div className="form-input-radio" style={{ paddingBottom: "2rem" }}>
                    <input type="checkbox" id="my-toggle" style={{ accentColor: "var(--green)" }} checked={isDefaultComponentFilter} onChange={() => setIsDefaultComponentFilter(!isDefaultComponentFilter)} />
                    <label htmlFor="my-toggle">{"Default components"}</label>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0rem 1rem 1rem 0rem', }}>
                    <p style={{ cursor: 'pointer', color: 'var(--red)' }}
                        onClick={() => {
                            setSelectedCategoryOption(null)
                            setSelectedTemplateOption(null)
                            setDecouncedSearchValue('');
                            setIsDefaultComponentFilter(false)
                            setSearchValue('')
                            setFilterValue('')
                            setSearchByRiderKey('')
                            setDecouncedFilterValue('')

                        }}
                    >Clear filters</p>

                    <p style={{ cursor: 'pointer', color: 'var(--green)' }} onClick={() => setShowMoreColumns(!showMoreColumns)}>{showMoreColumns ? 'Less Columns' : 'More Columns'}</p>

                </div>
            </>}





            {
                status === 'loading' ? (
                    <p>Loading...</p>
                ) : status === 'error' ? (
                    <span className='danger'>Error: {error.message}</span>
                ) : (
                    <>
                        <SharedTable
                            type={'templates'}
                            columns={columns}
                            items={results?.map(hit => ({ _id: hit?._id, ...hit?._source?.metadata }))}
                            activeDraftId={null}
                            hasNextPage={hasNextPage}
                            isLoading={isLoading}
                            isFetchingNextPage={isFetchingNextPage}
                            fetchNextPage={fetchNextPage}
                            isFetching={isFetching}
                            ref={ref}
                            onDetailHandler={async (rider) => {
                                console.log(rider)
                                const { benefitPlanCompKey } = rider
                                const benefitPlanComp = await fetchBnftPlanComp({ benefitPlanCompKey })
                                console.log(benefitPlanComp)
                                return benefitPlanComp.rows[0]
                            }}
                        />


                    </>
                )
            }


        </div>
    )
}

export default Templates